import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Building2, FileText, Scale, BookOpen, Mail, Phone, User, Menu, X, LogOut, ChevronDown } from 'lucide-react';
import { authSelector } from '../store/auth/selectors';
import { logoutRequest } from '../store/auth/actions';
import './Navbar.css';

const Navbar: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const userMenuRef = useRef<HTMLDivElement>(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isAuthenticated, user } = useSelector(authSelector);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (userMenuRef.current && !userMenuRef.current.contains(e.target as Node)) {
        setUserMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = () => {
    setUserMenuOpen(false);
    dispatch(logoutRequest(navigate));
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          <div className="logo-icon">DG</div>
          <span className="logo-name">DATAGREFFE</span>
        </Link>

        <div className={`navbar-links ${menuOpen ? 'open' : ''}`}>
          <Link to="/recherche" onClick={() => setMenuOpen(false)}>
            <Building2 size={16} />
            Entreprises
          </Link>
          <Link to="/aide" onClick={() => setMenuOpen(false)}>
            <FileText size={16} />
            Formalité
          </Link>
          <Link to="/aide" onClick={() => setMenuOpen(false)}>
            <Scale size={16} />
            Justice
          </Link>
          <Link to="/textes-de-loi" onClick={() => setMenuOpen(false)}>
            <BookOpen size={16} />
            Textes de loi
          </Link>
        </div>

        <div className="navbar-right">
          <div className="navbar-contact">
            <a href="mailto:contact@datagreffe.ci" className="contact-item">
              <Mail size={14} />
              contact@datagreffe.ci
            </a>
            <a href="tel:+2250718426314" className="contact-item">
              <Phone size={14} />
              07 18 42 63 14
            </a>
          </div>
          <div className="navbar-actions">
            <a href="https://formalite.datagreffe.ci/annonce" className="btn-services">Publier une Annonce</a>
            {isAuthenticated ? (
              <div className="user-menu-wrapper" ref={userMenuRef}>
                <button
                  className="btn-user-menu"
                  onClick={() => setUserMenuOpen(!userMenuOpen)}
                >
                  <User size={16} />
                  Espace Client
                  <ChevronDown size={14} className={`chevron ${userMenuOpen ? 'open' : ''}`} />
                </button>
                {userMenuOpen && (
                  <div className="user-dropdown">
                    <div className="user-dropdown-info">
                      <span className="user-dropdown-name">
                        {user?.first_name || user?.email || 'Client'}
                      </span>
                      {user?.email && (
                        <span className="user-dropdown-email">{user.email}</span>
                      )}
                    </div>
                    <div className="user-dropdown-divider" />
                    <button className="user-dropdown-item" onClick={handleLogout}>
                      <LogOut size={16} />
                      Déconnexion
                    </button>
                  </div>
                )}
              </div>
            ) : (
              <a href="https://datagreffe.ci/auth/login" className="btn-connexion">
                <User size={16} />
                Connexion
              </a>
            )}
          </div>
          <button className="icon-btn mobile-menu-btn" onClick={() => setMenuOpen(!menuOpen)}>
            {menuOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
